import { render, staticRenderFns } from "./ResponsivePlanTable.vue?vue&type=template&id=b476862c"
import script from "./ResponsivePlanTable.vue?vue&type=script&lang=js"
export * from "./ResponsivePlanTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports